import React from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';

import { CustomButton, CustomInput, Spinner } from 'components';
import { getUser, signIn } from 'store/thunks';
import { useAppDispatch, useAppSelector } from 'hooks';
import { PayloadState, User } from 'interfaces';
import { clearSignInRequestError } from 'store/slices';
import { loginValidationScheme } from 'validation';
import { ROUTES } from 'constants/routes';
import { getPostLoginRoute } from 'utils';

import './LoginForm.scss';

export const LoginForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { signInRequestStatus, signInRequestError } = useAppSelector(
    (state) => state.auth
  );

  const formik = useFormik({
    initialValues: { email: '', password: '' },
    onSubmit: (values) => {
      dispatch(clearSignInRequestError());

      dispatch(signIn(values)).then((data) => {
        if (data.meta.requestStatus === PayloadState.fulfilled) {
          dispatch(getUser()).then((userData) => {
            if (userData.meta.requestStatus === PayloadState.fulfilled) {
              const user = userData.payload as User;
              navigate(getPostLoginRoute(user.type), { replace: true });
            }
          });
        }
      });
    },
    validationSchema: loginValidationScheme,
  });

  return (
    <form onSubmit={formik.handleSubmit} className="login-form-container">
      <div className="login-form-input-box">
        <CustomInput
          id="email"
          name="email"
          label="Email address"
          placeholder="Enter email to get started"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.email && formik.errors.email && (
          <div className="login-form-validation-error">
            {formik.errors.email}
          </div>
        )}
      </div>
      <div className="login-form-input-box">
        <CustomInput
          id="password"
          name="password"
          type="password"
          label="Password"
          placeholder="Enter your password"
          width="100%"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.password && formik.errors.password && (
          <div className="login-form-validation-error">
            {formik.errors.password}
          </div>
        )}
      </div>
      {signInRequestStatus !== PayloadState.pending && (
        <CustomButton type="submit" text="Log in" width="100%" />
      )}
      {signInRequestStatus === PayloadState.pending && <Spinner />}
      {signInRequestError && (
        <div className="login-form-error">{signInRequestError}</div>
      )}

      <a href={ROUTES.register}>Register?</a>
    </form>
  );
};
